export const CONTACT = {
  email: 'donatiengrimaud@gmail.com',
  location: { en: 'Paris / International', fr: 'Paris / International' },
};

export const TITLE = 'RETAIL ARCHITECTURE & CREATIVE DIRECTOR';

export const SPECIALTIES = 'RETAIL ARCHITECTURE — LUXURY — BEAUTY & SPA — HOSPITALITY';

export const UI = {
  scroll: { en: 'Scroll', fr: 'Défiler' },
  selectedWork: { en: 'Selected work', fr: 'Projets choisis' },
  workTitle: { en: 'Work', fr: 'Projets' },
  chapterLabel: { en: 'Chapter', fr: 'Chapitre' },
  previous: { en: 'Previous', fr: 'Précédent' },
  next: { en: 'Next', fr: 'Suivant' },
  aboutTitle: { en: 'About', fr: 'À propos' },
  expertise: { en: 'Expertise', fr: 'Expertise' },
  career: { en: 'Career', fr: 'Parcours' },
  education: { en: 'Education', fr: 'Éducation' },
  languages: { en: 'Languages', fr: 'Langues' },
  downloadCV: { en: 'Download CV', fr: 'Télécharger le CV' },
  photoCount: { en: 'Photographs', fr: 'Photographies' },
  backToChapter: { en: 'Back to chapter', fr: 'Retour au chapitre' },
  plan: { en: 'Plan', fr: 'Plan' },
  gatePassword: { en: 'Enter password', fr: 'Saisir le mot de passe' },
  gateError: { en: 'Incorrect password', fr: 'Mot de passe incorrect' },
  gateEnter: { en: 'Enter', fr: 'Entrer' },
  download: { en: 'Portfolio — PDF · 140 MB', fr: 'Portfolio — PDF · 140 Mo' },
  downloadLight: { en: 'Portfolio — light version · PDF', fr: 'Portfolio — version allégée · PDF' },
};

export const BIO = {
  en: [
    'Interior architect specializing in Luxury and Premium Retail, with over 20 years in creative direction and international projects development for the fragrance, cosmetics, and spa sectors.',
    'I combine a strong sense of space, and proportions, with a deep knowledge of high-end materials. Focused on quality execution and attention to detail, I create retail concepts that are coherent and aligned with brand identity and customer experience.',
    'Experienced in international project leadership, I lead and support creative teams with high standards, agility and a collaborative mindset.',
  ],
  fr: [
    'Architecte d’intérieur spécialisé en Retail Luxe et Premium, avec plus de 20 ans d’expérience en direction créative et développement de projets internationaux pour les secteurs parfums, cosmétiques et spas.',
    'J’associe maîtrise des volumes, proportions et lumière à une expertise des matériaux et finitions haut de gamme. Attentif à l’excellence d’exécution et au détail, je développe des concepts retail cohérents au service de l’identité de marque et de l’expérience client.',
    'Expert en pilotage de projets internationaux, j’accompagne et manage des équipes créatives avec exigence, agilité et sens du collectif.',
  ],
};

export const ACHIEVEMENTS = [
  {
    text: {
      en: 'Creative, design and architectural direction of all international retail projects, approximately 300 projects per year.',
      fr: 'Direction créative, design et architecturale de l’ensemble des projets retail internationaux (environ 300 projets par an).',
    },
  },
  {
    text: {
      en: 'Creation, development and evolution of exclusive retail concepts including Dior Spa, La Collection Privée and Dior Backstage Studio.',
      fr: 'Création, développement et évolution des concepts retail exclusifs tels que Dior Spa, La Collection Privée et Dior Backstage Studio.',
    },
  },
  {
    text: {
      en: 'Development and global roll-out of the new architectural New Look concept: leadership and supervision of the first 20 international flagship pilot projects, development of architectural guidelines and global concept adaptation, and concept optimization and Design-to-Cost strategy.',
      fr: 'Développement et déploiement international du nouveau concept New Look : pilotage et suivi des 20 premiers projets flagships pilotes à l’international, élaboration des guidelines architecturales et déclinaison globale du concept, optimisation du concept et pilotage Design-to-Cost.',
    },
  },
];

export const CAREER = [
  {
    house: 'PARFUMS CHRISTIAN DIOR',
    role: { en: 'GLOBAL RETAIL ARCHITECTURE DIRECTOR', fr: 'GLOBAL RETAIL ARCHITECTURE DIRECTOR' },
    dates: { en: 'April 2018 – Present – 8 years', fr: 'Avril 2018 – Présent – 8 ans' },
  },
  {
    house: 'PARFUMS CHRISTIAN DIOR',
    role: { en: 'HEAD OF RETAIL ARCHITECTURE DEVELOPMENT', fr: 'HEAD OF RETAIL ARCHITECTURE DEVELOPMENT' },
    dates: { en: 'June 2010 – April 2018 – 8 years', fr: 'Juin 2010 – Avril 2018 – 8 ans' },
  },
  {
    house: 'PARFUMS CHRISTIAN DIOR',
    role: { en: 'INTERNATIONAL RETAIL ARCHITECT – EUROPE', fr: 'INTERNATIONAL RETAIL ARCHITECT – EUROPE' },
    dates: { en: 'December 2007 – May 2010 – 3 years', fr: 'Décembre 2007 – Mai 2010 – 3 ans' },
  },
  {
    house: 'L’ORÉAL - PRODUIT DE LUXE FRANCE',
    role: { en: 'RETAIL ARCHITECT - ASSISTANT', fr: 'RETAIL ARCHITECT - ASSISTANT' },
    dates: { en: 'February 2005 – September 2005 – 8 months', fr: 'Février 2005 – Septembre 2005 – 8 mois' },
  },
];

export const EDUCATION = [
  {
    school: { en: 'STRATE SCHOOL OF DESIGN', fr: 'STRATE ÉCOLE DE DESIGN' },
    detail: { en: '2002 – 2007 — Industrial Design Degree, Product & Luxury Design, Master’s Degree Level', fr: '2002 – 2007 — Diplôme de Designer Industriel, Spécialité Design Produit & Luxe, Niveau Master II' },
  },
  {
    school: { en: 'SCIENTIFIC BACCALAUREAT', fr: 'BACCALAURÉAT SCIENTIFIQUE' },
    detail: { en: '2002 — Institut Notre-Dame – Meudon — Physics – Chemistry', fr: '2002 — Institut Notre de Dame - Meudon — Spécialité Physique - Chimie' },
  },
];

export const LANGUAGES = {
  en: ['French – Native', 'English – Fluent', 'Spanish – Basic'],
  fr: ['Français maternel', 'Anglais courant', 'Espagnol notions'],
};

export const EXPERTISE = [
  { en: 'Luxury Retail & Interior Architecture', fr: 'Architecture intérieure & Retail Luxe' },
  { en: 'Creative Direction & Concept Design', fr: 'Direction créative & Concept Design' },
  { en: 'Customer Experience & Journey', fr: 'Expérience client & parcours' },
  { en: 'Premium Materials & Finishes', fr: 'Matériaux & finitions premium' },
  { en: 'Design Guidelines & Design-to-Cost', fr: 'Design Guidelines & Design-to-Cost' },
  { en: 'Global Retail Roll-out', fr: 'Déploiement retail international' },
  { en: 'Creative Team Leadership', fr: 'Management d’équipes créatives' },
  { en: 'International Project Management', fr: 'Coordination & pilotage de projets' },
  { en: 'Flagship Development & Roll-out', fr: 'Développement Flagships & Roll-out' },
  { en: 'Brand Identity & Consistency', fr: 'Identité & cohérence de marque' },
  { en: 'Execution Excellence & Quality', fr: 'Excellence & qualité d’exécution' },
  { en: 'Creativity & Strategic Vision', fr: 'Créativité & vision stratégique' },
];

const P = (s, ar) => ({ s, ar });

export const CHAPTERS = [
  {
    slug: 'new-look',
    numeral: 'I',
    title: 'NEW LOOK',
    cover: '/work/cover-new-look.jpg',
    intro: {
      en: 'The New Look: a refined design that seeks the emotion of beauty through execution, premium materials, and beautiful details, inspired by the excellence of Couture boutiques. A powerful identity expressed through verticality. A modern, welcoming luxury.',
      fr: 'Le New-Look : Un design épuré qui recherche l’émotion du beau dans l’exécution, les belles matières et les beaux détails, inspiré par l’excellence des boutiques Couture. Une identité puissante qui se traduit par des verticales. Un luxe moderne et accueillant.',
    },
    expertiseLine: {
      en: 'Creative development — Retail concept development — Premium materials & finishes — Design to cost',
      fr: 'Développement créatif — Développement concept retail — Matériaux & finitions premium — Conception & maîtrise des coûts',
    },
    quote: {
      en: '“Perhaps this will be my way of giving in to an avowed taste for interior decoration and architecture, my first and true calling?”',
      fr: '« Peut-être céderai-je ainsi à mon goût pour la décoration et l’architecture, ma première et véritable vocation ? »',
      author: 'Christian Dior, Christian Dior et Moi, 1956',
    },
    projects: [
      {
        slug: 'haute-parfumerie',
        title: 'HAUTE PARFUMERIE',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'The Haute Parfumerie Boutique Atelier, mirroring the couturier parfumeur spirit of the Montaigne workshops. It is deeply connected to Couture with a luxurious and modern twist of the Parisian style. It is the expression of all the aspects of the Maison Dior.',
            fr: 'La Haute Parfumerie, reflet de l’esprit du couturier-parfumeur des ateliers de l’avenue Montaigne. Profondément liée à l’univers de la Couture, elle revisite le style parisien dans une interprétation à la fois luxueuse et contemporaine. Elle incarne l’expression de toutes les facettes de la Maison Dior.',
          },
        ],
        photos: [P('hp-1','std'), P('hp-2','std'), P('hp-4','std'), P('hp-5','std')],
        gallery: [
          [{ s: 'hp-1', ar: 'std', c: 3 }, { s: 'hp-2', ar: 'std', c: 3 }],
          [{ s: 'hp-4', ar: 'std', c: 3 }, { s: 'hp-5', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'vic-lounge',
        title: 'VIC LOUNGE',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'The VIC lounges offer a premium, private and intimate setting, designed as a cocoon where clients can discover the full fragrance universe of Dior, as well as the Maison’s most exceptional creations.',
            fr: 'Les lounges VIC offrent un espace privatif, premium et intimiste, pensé comme un véritable cocon où les clients peuvent découvrir en toute exclusivité l’univers des fragrances Dior, ainsi que les pièces les plus exceptionnelles de la Maison.',
          },
        ],
        photos: [P('vic-1','std'), P('vic-2','std'), P('vic-3','std'), P('hp-7','std')],
        gallery: [
          [{ s: 'vic-1', ar: 'std', c: 3 }, { s: 'vic-2', ar: 'std', c: 3 }],
          [{ s: 'vic-3', ar: 'std', c: 3 }, { s: 'hp-7', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'fragrance',
        title: 'FRAGRANCE',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'The Scent Wardrobe. A warm, luminous and immersive environment where Dior’s iconic creations come to life: J’adore, Miss Dior and Sauvage. A dedicated Men’s space.',
            fr: 'Le dressing des sens. Une expression globale, lumineuse et chaude dans laquelle s’expriment les grandes créations : J’adore, Miss Dior et Sauvage. Un espace Hommes dédié.',
          },
        ],
        photos: [P('frag-1','std'), P('frag-2','std')],
        gallery: [
          [{ s: 'frag-1', ar: 'std', c: 3 }, { s: 'frag-2', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'skincare',
        title: 'SKINCARE',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'Skincare, in line with the high-end spas, balances ultra-luxurious cocooning and avant-garde science.',
            fr: 'Skincare, dans la continuité des spas haut de gamme, équilibre entre une expérience cocooning ultra-luxueuse et une approche scientifique à la pointe de l’innovation.',
          },
        ],
        photos: [P('skin-1','std'), P('skin-2','std'), P('skin-3','std')],
        gallery: [
          [{ s: 'skin-1', ar: 'std', c: 3 }, { s: 'skin-2', ar: 'std', c: 3 }],
          [{ s: 'skin-3', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'skincare-consultations',
        title: 'SKINCARE CONSULTATIONS',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'A warm, comfortable and luxurious place to be looked after, with services and technologies.',
            fr: 'Un espace chaleureux, confortable et luxueux, pensé pour prendre soin de soi, grâce à des services et des technologies de pointe.',
          },
        ],
        photos: [P('skincon-1','tall'), P('skincon-2','tall')],
        gallery: [
          [{ s: 'skincon-1', ar: 'tall', c: 3 }, { s: 'skincon-2', ar: 'tall', c: 3 }],
        ],
      },
      {
        slug: 'make-up',
        title: 'MAKE-UP',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'Makeup personifying the colorful, youthful energy of the catwalk and the dynamic spirit of Dior Backstage. A digital screen welcomes visitors, showcasing the latest fashion show and bringing the Maison’s backstage atmosphere to life.',
            fr: 'Le maquillage incarne l’énergie colorée et jeune des podiums, ainsi que l’esprit dynamique de Dior Backstage. Un écran digital accueille les visiteurs en présentant le dernier défilé de la Maison, donnant vie à l’atmosphère des backstages.',
          },
        ],
        photos: [P('makeup-4','wide'), P('makeup-1','std'), P('makeup-2','std'), P('makeup-3','std')],
        gallery: [
          [{ s: 'makeup-4', ar: 'wide', c: 6 }],
          [{ s: 'makeup-1', ar: 'std', c: 3 }, { s: 'makeup-2', ar: 'std', c: 3 }],
          [{ s: 'makeup-3', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'backstage-studio',
        title: 'BACKSTAGE STUDIO',
        caption: null,
        credits: null,
        texts: [
          {
            en: 'Inspired by the backstage world of Dior fashion shows, the Dior Backstage retail concept brings makeup essentials into a modern, youthful environment. Its modular furniture and lighting reflect the Maison’s distinctive backstage codes.',
            fr: 'Inspiré des coulisses des défilés Dior, le concept retail Dior Backstage réunit les essentiels du maquillage dans un univers moderne et jeune. Son mobilier modulable et sa mise en lumière reprennent les codes du backstage de la Maison.',
          },
        ],
        photos: [P('back-1','std'), P('back-2','std'), P('back-3','std'), P('back-4','std')],
        gallery: [
          [{ s: 'back-1', ar: 'std', c: 3 }, { s: 'back-2', ar: 'std', c: 3 }],
          [{ s: 'back-3', ar: 'std', c: 3 }, { s: 'back-4', ar: 'std', c: 3 }],
        ],
      },
    ],
  },
  {
    slug: 'retail',
    numeral: 'II',
    title: 'BEAUTY RETAIL',
    cover: '/work/cover-retail.jpg',
    intro: {
      en: 'International roll-out of the New Look concept across a global network of boutiques and counters, adapting the Maison’s architectural identity to each market and location. A global approach ensuring consistency, execution excellence and respect for design standards, from design development to opening.',
      fr: 'Déploiement international du concept New Look à travers un réseau de boutiques et de corners, en adaptant l’identité architecturale de la Maison aux spécificités de chaque marché. Une approche globale garantissant cohérence, excellence d’exécution et respect des standards, de la conception jusqu’à l’ouverture.',
    },
    expertiseLine: {
      en: 'Global concept roll out — Global design guidelines — International project mgmt — Creative team leadership',
      fr: 'Déploiement concepts — Pilotage des projets int. — Standards & guidelines int. — Management d’équipes créatives',
    },
    rollout: {
      image: 'map-world',
      title: { en: 'GLOBAL ROLL-OUT', fr: 'ROLL-OUT INTERNATIONAL' },
      subtitle: { en: 'Selection of recent flagship openings', fr: 'Sélection des dernières ouvertures de flagships' },
    },
    regions: [
      {
        name: { en: 'EUROPE', fr: 'EUROPE' },
        projects: [
          { name: 'LONDON HARRODS', spec: { en: '170 sqm – 2025', fr: '170 m² – 2025' }, photo: 'eu-harrods', plan: 'eu-harrods-plan' },
          { name: 'LONDON SELFRIDGES', spec: { en: '74 sqm – 2025', fr: '74 m² – 2025' }, photo: 'eu-selfridges-1', plan: 'eu-selfridges-1-plan' },
          { name: 'LONDON SELFRIDGES', spec: { en: '54 sqm – 2025', fr: '54 m² – 2025' }, photo: 'eu-selfridges-2', plan: 'eu-selfridges-2-plan' },
        ],
      },
      {
        name: { en: 'AMERICAS', fr: 'AMÉRIQUES' },
        projects: [
          { name: 'LA SOUTH COAST PLAZA', spec: { en: '130 sqm – 2025', fr: '130 m² – 2025' }, photo: 'am-scp', plan: 'am-scp-plan' },
          { name: 'TORONTO YORKDALE', spec: { en: '120 sqm – 2025', fr: '120 m² – 2025' }, photo: 'am-yorkdale', plan: 'am-yorkdale-plan' },
          { name: 'NYC BERGDORF GOODMAN', spec: { en: '54 sqm – 2025', fr: '54 m² – 2025' }, photo: 'am-bg', plan: 'am-bg-plan' },
        ],
      },
      {
        name: { en: 'MIDDLE-EAST', fr: 'MOYEN-ORIENT' },
        projects: [
          { name: 'KSA RED SEA MALL', spec: { en: '250 sqm – 2025', fr: '250 m² – 2025' }, photo: 'me-ksa', plan: 'me-ksa-plan' },
          { name: 'ABU DHABI MARINA MALL', spec: { en: '180 sqm – 2025', fr: '180 m² – 2025' }, photo: 'me-abudhabi', plan: 'me-abudhabi-plan' },
          { name: 'KUWAIT THE AVENUE', spec: { en: '140 sqm – 2025', fr: '140 m² – 2025' }, photo: 'me-kuwait', plan: 'me-kuwait-plan' },
        ],
      },
      {
        name: { en: 'JAPAN', fr: 'JAPON' },
        projects: [
          { name: 'TOKYO GINZA 6', spec: { en: '220 sqm – 2024', fr: '220 m² – 2024' }, photo: 'jp-ginza', plan: 'jp-ginza-plan' },
          { name: 'OSAKA HANKYU UMEDA', spec: { en: '60 sqm – 2026', fr: '60 m² – 2026' }, photo: 'jp-hankyu', plan: 'jp-hankyu-plan' },
          { name: 'KYOTO ISETAN', spec: { en: '205 sqm – 2024', fr: '205 m² – 2024' }, photo: 'jp-kyoto', plan: 'jp-kyoto-plan' },
        ],
      },
      {
        name: { en: 'CHINA', fr: 'CHINE' },
        projects: [
          { name: 'SHANGHAI TAIKOO HUI', spec: { en: '210 sqm – 2025', fr: '210 m² – 2025' }, photo: 'ch-shanghai', plan: 'ch-shanghai-plan' },
          { name: 'GUANGZHOU PARK CENTRAL', spec: { en: '168 sqm – 2025', fr: '168 m² – 2025' }, photo: 'ch-guangzhou', plan: 'ch-guangzhou-plan' },
          { name: 'CHENGDU IFS', spec: { en: '161 sqm – 2025', fr: '161 m² – 2025' }, photo: 'ch-chengdu', plan: 'ch-chengdu-plan' },
        ],
      },
      {
        name: { en: 'ASIA PACIFIC', fr: 'ASIE PACIFIQUE' },
        projects: [
          { name: 'THAILAND ICON SIAM', spec: { en: '260 sqm – 2025', fr: '260 m² – 2025' }, photo: 'ap-iconsiam', plan: 'ap-iconsiam-plan' },
          { name: 'HONG-KONG IFC', spec: { en: '190 sqm – 2025', fr: '190 m² – 2025' }, photo: 'ap-hkifc', plan: 'ap-hkifc-plan' },
          { name: 'TAIWAN TAIPEI 101', spec: { en: '161 sqm – 2025', fr: '161 m² – 2025' }, photo: 'ap-taipei', plan: 'ap-taipei-plan' },
        ],
      },
    ],
  },
  {
    slug: 'spa',
    numeral: 'III',
    title: 'SPA & WELLNESS',
    cover: '/work/cover-spa.jpg',
    intro: {
      en: 'The essence of Dior Spas: the House of Dior captures the unique character of exceptional places and fills them with its spirit and architectural expertise to create extraordinary spas. A well-being stopover to experience in exceptional settings.',
      fr: 'L’essence des Spas Dior : La Maison Dior capture ce qui fait la singularité d’adresses d’exception et les imprègne de son esprit et de son savoir-faire architectural pour créer des spas extraordinaires. Une escale bien-être d’exception à vivre dans des écrins hors norme.',
    },
    expertiseLine: {
      en: 'Spa & wellness / hospitality — Retail innovation — Customer experience',
      fr: 'Spa & wellness / hospitality — Innovation retail — Expérience client',
    },
    projects: [
      {
        slug: 'plaza-athenee',
        title: 'PLAZA ATHÉNÉE',
        caption: { en: 'Paris Montaigne – 2024 – 200 sqm', fr: 'Paris Montaigne – 2024 – 200 m²' },
        credits: {
          en: 'Artistic Direction : T. Mick / Labvert — Photography : Matthieu Salvaing',
          fr: 'Direction Artistique : T. Mick / Labvert — Photographie : Matthieu Salvaing',
        },
        texts: [
          {
            en: 'Located within the prestigious Hôtel Plaza Athénée in Paris, Dior Spa offers a wellness retreat in the heart of the capital. Its refined interior, featuring beige and taupe tones enhanced by touches of gold, creates an elegant and soothing atmosphere.',
            fr: 'Situé au sein du prestigieux Hôtel Plaza Athénée à Paris, le Dior Spa offre une parenthèse de bien-être au cœur de la capitale. Son intérieur raffiné, aux tons beige et taupe rehaussés de touches dorées, crée une atmosphère élégante et apaisante.',
          },
          {
            en: 'Dior’s iconic codes are subtly integrated throughout, while a marble fountain fills the reception area with the gentle sound of flowing water. The treatment rooms invite guests to experience absolute relaxation.',
            fr: 'Les codes emblématiques de Dior y sont subtilement intégrés, tandis qu’une fontaine en marbre diffuse le doux son de l’eau dans l’espace d’accueil. Les cabines de soin invitent à la détente absolue.',
          },
        ],
        photos: [P('plaza-1','wide'), P('plaza-2','std'), P('plaza-3','std'), P('plaza-4','std'), P('plaza-5','tall'), P('plaza-6','std'), P('plaza-7','tall')],
        gallery: [
          [{ s: 'plaza-1', ar: 'wide', c: 6 }],
          [{ s: 'plaza-2', ar: 'std', c: 3 }, { s: 'plaza-3', ar: 'std', c: 3 }],
          [{ s: 'plaza-4', ar: 'std', c: 3 }, { s: 'plaza-6', ar: 'std', c: 3 }],
          [{ s: 'plaza-5', ar: 'tall', c: 3 }, { s: 'plaza-7', ar: 'tall', c: 3 }],
        ],
      },
      {
        slug: 'the-lana',
        title: 'THE LANA',
        caption: { en: 'Dubai – 2024 – 750 sqm', fr: 'Dubaï – 2024 – 750 m²' },
        credits: {
          en: 'Photography : Pierre Mouton',
          fr: 'Photographie : Pierre Mouton',
        },
        texts: [
          {
            en: 'Spaces dedicated to rest and well-being. Above the clouds, step into a bubble of serenity, where each treatment room offers its own private space for relaxation. Designed to be Dubai’s most exclusive holistic escape, Dior Spa The Lana also offers a curated selection of yoga and fitness experiences, to be enjoyed while taking in the city’s most breathtaking views.',
            fr: 'Des espaces dédiés au repos et au bien-être. Au-dessus des nuages, pénétrez dans une bulle de sérénité où chaque cabine bénéficie de son espace privé de relaxation. Imaginé pour être l’échappée holistique la plus exclusive de Dubaï, le Dior Spa The Lana propose également une offre de yoga et de gym, à découvrir tout en profitant de la plus belle vue de la ville.',
          },
        ],
        photos: [P('lana-3','wide'), P('lana-1','tall'), P('lana-2','tall'), P('lana-4','wide')],
        gallery: [
          [{ s: 'lana-3', ar: 'wide', c: 6 }],
          [{ s: 'lana-1', ar: 'tall', c: 3 }, { s: 'lana-2', ar: 'tall', c: 3 }],
          [{ s: 'lana-4', ar: 'wide', c: 6 }],
        ],
      },
      {
        slug: 'eden-roc',
        title: 'EDEN ROC',
        caption: { en: 'Cap d’Antibes – 2023 – 400 sqm', fr: 'Cap d’Antibes – 2023 – 400 m²' },
        credits: {
          en: 'Artistic Direction : T. Mick / Labvert — Photography : Matthieu Salvaing',
          fr: 'Direction Artistique : T. Mick / Labvert — Photographie : Matthieu Salvaing',
        },
        texts: [
          {
            en: 'Ideally located on the French Riviera, the legendary Hôtel du Cap-Eden-Roc is home to an exclusive Dior Spa. Nestled within the lush Eden-Roc gardens, this wellness retreat combines understated elegance with authentic luxury. Inspired by the estate’s natural rock formations, the interiors feature warm sandy tones enhanced by Dior’s signature codes and textiles.',
            fr: 'Idéalement situé sur la Côte d’Azur, le mythique Hôtel du Cap-Eden-Roc accueille un Dior Spa exclusif. Niché au cœur des jardins luxuriants de l’Eden-Roc, ce havre de bien-être conjugue élégance discrète et luxe authentique. Inspiré par les roches naturelles du domaine, l’espace se décline dans des tonalités sableuses où les codes emblématiques de Dior s’intègrent avec subtilité.',
          },
          {
            en: 'Spanning 400 sqm, the spa includes four treatment rooms, a sauna, and a hammam. A boutique showcases Collection Privée Christian Dior fragrances, including Eden-Roc, alongside a curated selection of skincare, beauty, and fashion products. The experience extends into the gardens with a gazebo and a cabana overlooking the Mediterranean Sea.',
            fr: 'Réparti sur 400 m², le spa comprend quatre cabines de soin, un sauna, un hammam ainsi qu’une spectaculaire suite d’affusion en onyx. Une boutique propose les parfums de la Collection Privée Christian Dior, dont Eden-Roc, ainsi qu’une sélection de produits de beauté, de soin et d’accessoires de la Maison. L’expérience se prolonge dans le jardin avec un pavillon et une cabane offrant une vue imprenable sur la Méditerranée.',
          },
        ],
        photos: [P('eden-1','tall'), P('eden-2','std'), P('eden-3','std'), P('eden-4','band'), P('eden-5','std')],
        gallery: [
          [{ s: 'eden-1', ar: 'tall', c: 3 }],
          [{ s: 'eden-2', ar: 'std', c: 3 }, { s: 'eden-3', ar: 'std', c: 3 }],
          [{ s: 'eden-4', ar: 'band', c: 6 }],
          [{ s: 'eden-5', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'new-york-57th',
        title: 'DIOR COUTURE',
        caption: { en: 'New York 57th – 2025 – 320 sqm', fr: 'New York 57th – 2025 – 320 m²' },
        credits: {
          en: 'Artistic Direction : PMA — Partnership : Dior Couture — Photography : Jonathan Taylor',
          fr: 'Direction Artistique : PMA — Collaboration : Dior Couture — Photographie : Jonathan Taylor',
        },
        texts: [
          {
            en: 'In 2025, Dior opens its first permanent Spa in the US, located on top of its New York flagship. For the first time, the House dedicates an entire floor to the world of wellness, creating a unique destination devoted to beauty excellence and the Dior Spa experience. Inspired by Monsieur Dior’s words on the elegance of American women, this new space, developed in collaboration with architect Peter Marino, marks a new chapter in the reinvention of Dior’s New York flagship.',
            fr: 'En 2025, Dior inaugure son premier Spa permanent aux États-Unis, au sommet de son flagship new-yorkais. Pour la première fois, la Maison consacre un étage entier à l’univers du bien-être, créant une adresse unique dédiée à l’excellence de la beauté et Dior Spa. Inspiré par les mots de Monsieur Dior sur l’élégance des Américaines, ce nouvel espace, imaginé en collaboration avec l’architecte Peter Marino, marque une nouvelle étape dans la réinvention du flagship de New York.',
          },
        ],
        photos: [P('nyc-1','std'), P('nyc-2','std'), P('nyc-3','std'), P('nyc-4','std')],
        gallery: [
          [{ s: 'nyc-1', ar: 'std', c: 3 }, { s: 'nyc-2', ar: 'std', c: 3 }],
          [{ s: 'nyc-3', ar: 'std', c: 3 }, { s: 'nyc-4', ar: 'std', c: 3 }],
        ],
      },
    ],
  },
  {
    slug: 'heritage',
    numeral: 'IV',
    title: 'HERITAGE',
    cover: '/work/cover-heritage.jpg',
    intro: {
      en: 'Scenography projects on exceptional heritage sites: Château de la Colle Noire, Les Fontaines Parfumées, Dior Héritage, and Château d’Yquem. Each project blends restoration of historic architecture with refined contemporary design in service of brand storytelling. These works showcase expertise in bridging heritage, museography, and high-end retail.',
      fr: 'Projets de scénographie sur des lieux patrimoniaux d’exception : Château de la Colle Noire, Les Fontaines Parfumées, Dior Héritage et Château d’Yquem. Chaque intervention allie restauration du bâti historique et design contemporain épuré au service du récit de marque. Ces réalisations illustrent une expertise du dialogue entre patrimoine, muséographie et retail haut de gamme.',
    },
    expertiseLine: {
      en: 'Brand identity & consistency — Design excellence — Scenography & museum design',
      fr: 'Identité & cohérence de marque — Excellence design — Design muséographique',
    },
    projects: [
      {
        slug: 'la-colle-noire',
        title: 'LA COLLE NOIRE',
        caption: { en: 'Montauroux – 2016 – 54 sqm', fr: 'Montauroux – 2016 – 54 m²' },
        credits: {
          en: 'Artistic Direction : T. Mick / Labvert — Photography : G. Grasset',
          fr: 'Direction Artistique : T. Mick / Labvert — Photographie : G. Grasset',
        },
        texts: [
          {
            en: 'Château de la Colle Noire in Montauroux, Christian Dior’s former residence, inspired some of his most iconic fragrances. We designed a museum that traces the history of Dior perfumes. Historic bottles and original sketches are presented in a refined scenography where heritage and contemporary design meet in harmony.',
            fr: 'Le Château de la Colle Noire à Montauroux, ancienne demeure de Christian Dior, a inspiré certaines de ses plus grandes créations olfactives. Nous y avons conçu un musée retraçant l’histoire des fragrances Dior. Flacons historiques et croquis originaux sont mis en scène dans une scénographie épurée, où patrimoine et design contemporain dialoguent avec élégance.',
          },
        ],
        photos: [P('colle-1','tall'), P('colle-2','std'), P('colle-3','std'), P('colle-4','std')],
        gallery: [
          [{ s: 'colle-1', ar: 'tall', c: 3 }],
          [{ s: 'colle-2', ar: 'std', c: 3 }, { s: 'colle-3', ar: 'std', c: 3 }],
          [{ s: 'colle-4', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'fontaines-parfumees',
        title: 'FONTAINES PARFUMÉES',
        caption: { en: 'Grasse – 2016 – 800 sqm', fr: 'Grasse – 2016 – 800 m²' },
        credits: {
          en: 'Artistic Direction : T. Mick / Louis Vuitton — Partnership : Inca',
          fr: 'Direction Artistique : T. Mick / Louis Vuitton — Collaboration : Inca',
        },
        texts: [
          {
            en: 'In the heart of Grasse, a ruined 17th-century bastide was restored and redecorated to become Les Fontaines Parfumées, the birthplace of Christian Dior and Louis Vuitton fragrances. Through meticulous restoration, the estate now provides to our perfumers a unique setting for perfume creation. Surrounded by rare plants, fragrant flowers, and fruit trees, the property blends heritage, nature, and inspiration.',
            fr: 'Au cœur de Grasse, une bastide du XVIIe siècle en ruine a été restaurée et redécorée pour devenir Les Fontaines Parfumées, berceau des créations olfactives de Christian Dior et de Louis Vuitton. Une restauration minutieuse a permis d’offrir à François Demachy et à Jacques Cavalier un lieu unique dédié à la création. Entouré d’un jardin de fleurs, d’essences rares et d’arbres fruitiers, le domaine conjugue patrimoine, nature et inspiration.',
          },
        ],
        photos: [P('fontaines-1','std'), P('fontaines-2','std'), P('fontaines-3','std'), P('fontaines-4','std')],
        gallery: [
          [{ s: 'fontaines-1', ar: 'std', c: 3 }, { s: 'fontaines-2', ar: 'std', c: 3 }],
          [{ s: 'fontaines-3', ar: 'std', c: 3 }, { s: 'fontaines-4', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'dior-heritage',
        title: 'DIOR HÉRITAGE',
        caption: { en: 'Paris Montaigne – 2016 – 220 sqm', fr: 'Paris Montaigne – 2016 – 220 m²' },
        credits: {
          en: 'Partnership : mil* — Photography : Adrien Dirand',
          fr: 'Collaboration : mil* — Photographie : Adrien Dirand',
        },
        texts: [
          {
            en: 'Dior Heritage brings together offices, a showroom, and preservation spaces for the historic Dior Couture collection. Inspired by the House’s codes, the project places the collection at center stage. Designed as a showcase, it enhances the pieces on display without overshadowing them. The accessory and fragrance reserves define a sanctuary, and the archives an intimate library.',
            fr: 'Dior Heritage réunit bureaux, showroom et espaces de conservation dédiés à la collection historique de Dior Couture. Inspiré des codes de la Maison, le projet met en valeur l’essentiel : la collection. Conçu comme un écrin, il sublime les pièces présentées sans jamais les éclipser. Les réserves d’accessoires et de parfums deviennent un sanctuaire, et les archives documentaires une bibliothèque intime.',
          },
        ],
        photos: [P('heritage-1','tall'), P('heritage-4','wide'), P('heritage-3','portrait'), P('heritage-2','landscape')],
        gallery: [
          [{ s: 'heritage-1', ar: 'tall', c: 3 }],
          [{ s: 'heritage-4', ar: 'wide', c: 6 }],
          [{ s: 'heritage-3', ar: 'portrait', c: 2 }, { s: 'heritage-2', ar: 'landscape', c: 4 }],
        ],
      },
      {
        slug: 'chateau-dyquem',
        title: 'CHÂTEAU D’YQUEM',
        caption: { en: 'Sauternes – 2016 – 180 sqm', fr: 'Sauternes – 2016 – 180 m²' },
        credits: {
          en: 'Artistic Direction : T. Mick / Labvert — Renders : H. Holba',
          fr: 'Direction Artistique : T. Mick / Labvert — Renders : H. Holba',
        },
        texts: [
          {
            en: 'Château d’Yquem, the prestigious estate south of Bordeaux renowned for its Sauternes wines, commissioned us to design a new presentation and retail space. Inspired by the shape of oak barrels, the concept displays the bottles on curved staves using custom-designed illuminated stands.',
            fr: 'Le Château d’Yquem, prestigieux domaine situé au sud de Bordeaux et célèbre pour ses vins de Sauternes, nous a confié la conception d’un nouvel espace de présentation et de vente. Inspirée par la forme des barriques en chêne, la scénographie met en valeur les bouteilles sur des douelles courbes grâce à des présentoirs spécialement conçus et éclairés.',
          },
        ],
        photos: [P('yquem-1','tall'), P('yquem-2','wide'), P('yquem-3','wide'), P('yquem-4','wide')],
        gallery: [
          [{ s: 'yquem-1', ar: 'tall', c: 3 }],
          [{ s: 'yquem-2', ar: 'wide', c: 6 }],
          [{ s: 'yquem-3', ar: 'wide', c: 6 }, { s: 'yquem-4', ar: 'wide', c: 6 }],
        ],
      },
    ],
  },
  {
    slug: 'partnerships',
    numeral: 'V',
    title: 'PARTNERSHIPS',
    cover: '/work/cover-partnerships.jpg',
    intro: {
      en: 'Retail projects in partnership with major luxury houses: Dior Couture boutiques (Paris, Vienna, Hong Kong, New York), and concepts for Fendi, Céline, and Givenchy. Each project translates the House’s identity through cohesive scenography serving both product and customer experience. Realized between 2020 and 2025, they showcase expertise in luxury retail, from pop-up counters to flagship stores.',
      fr: 'Projets retail en partenariat avec de grandes maisons : Boutiques Dior Couture (Paris, Vienne, Hong Kong, New York), ainsi que des concepts pour Fendi, Céline et Givenchy. Chaque projet traduit l’identité propre de la Maison à travers une scénographie cohérente au service du produit et de l’expérience client. Réalisés entre 2020 et 2025, ils illustrent une expertise du retail de luxe, du corner éphémère au flagship.',
    },
    expertiseLine: {
      en: 'Luxury brand architecture — Cross-functional leadership — Strategic retail development',
      fr: 'Leadership transverse — Architecture de marques de luxe — Développement stratégique',
    },
    projects: [
      {
        slug: 'dior-couture-paris',
        title: 'DIOR COUTURE',
        caption: { en: 'Paris Montaigne – 2022 – 76 sqm', fr: 'Paris Montaigne – 2022 – 76 m²' },
        credits: {
          en: 'Partnership : Dior Couture — Photography : Kristen Pelou',
          fr: 'Partnership : Dior Couture — Photographie : Kristen Pelou',
        },
        texts: [
          {
            en: 'The integration of the Fragrance & Beauty area within the Dior Couture boutique strengthens the connection between two essential facets of the House, creating a more cohesive and immersive experience. Embellished with sculpted plaster roses, the space features a redesigned product presentation with a more premium and lifestyle-oriented approach. Above the bar, floral artworks complete the setting, adding a touch of elegance and contemporary refinement.',
            fr: 'L’intégration de l’espace Parfums & Beauté au sein de la boutique Dior Couture renforce le dialogue entre deux univers indissociables de la Maison, créant une expérience plus cohérente et immersive. Les murs habillés de roses en plâtre en relief offrent un décor raffiné, tandis que la présentation des produits a été repensée dans un esprit plus premium et lifestyle. Au-dessus du bar, des compositions florales viennent compléter cette mise en scène élégante et contemporaine.',
          },
        ],
        photos: [P('dparis-1','tall'), P('dparis-4','wide'), P('dparis-2','std'), P('dparis-3','std')],
        gallery: [
          [{ s: 'dparis-1', ar: 'tall', c: 3 }],
          [{ s: 'dparis-4', ar: 'wide', c: 6 }],
          [{ s: 'dparis-2', ar: 'std', c: 3 }, { s: 'dparis-3', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'dior-couture-vienna',
        title: 'DIOR COUTURE',
        caption: { en: 'Vienna – 2025 – 96 sqm', fr: 'Vienna – 2025 – 96 m²' },
        credits: {
          en: 'Partnership : Dior Couture — Photography : Jonathan Taylor',
          fr: 'Partnership : Dior Couture — Photographie : Jonathan Taylor',
        },
        texts: [
          {
            en: 'Building on the design and success of the Montaigne boutique, we collaborated with Dior Couture to further integrate the Perfumes & Beauty spaces within its stores. With its prime location and generous proportions, the Vienna boutique provides an ideal setting for this universe. It showcases the fragrance collections in a refined and understated environment.',
            fr: 'Dans le prolongement du succès de la boutique de Montaigne, nous avons collaboré avec Dior Couture pour poursuivre l’intégration des espaces Parfums & Beauté au sein de ses boutiques. Par son emplacement et ses proportions, la boutique de Vienne offre un cadre idéal à cet univers. Elle met en valeur les créations parfumées dans un écrin sobre et raffiné.',
          },
        ],
        photos: [P('dvienna-1','std'), P('dvienna-2','std'), P('dvienna-3','std'), P('dvienna-4','std')],
        gallery: [
          [{ s: 'dvienna-1', ar: 'std', c: 3 }, { s: 'dvienna-2', ar: 'std', c: 3 }],
          [{ s: 'dvienna-3', ar: 'std', c: 3 }, { s: 'dvienna-4', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'dior-couture-hong-kong',
        title: 'DIOR COUTURE',
        caption: { en: 'Hong Kong Lee Garden – 2025 – 54 sqm', fr: 'Hong Kong Lee Garden – 2025 – 54 m²' },
        credits: {
          en: 'Partnership : Dior Couture — Photography : Dior & Jonathan Taylor',
          fr: 'Partnership : Dior Couture — Photographie : Dior & Jonathan Taylor',
        },
        texts: [
          {
            en: 'In 2025, Dior renovates its boutique at Lee Garden in Hong Kong, expanding it with a new area dedicated to fragrances and beauty. Designed around exceptional service and exclusive client experiences, the space features a premium consultation lounge and a private Dior treatment suite located at the rear of the boutique. Together, these additions strengthen the House’s presence and establish a meaningful connection with the world of Dior Couture.',
            fr: 'En 2025, Dior rénove sa boutique de Lee Garden à Hong Kong en l’agrandissant d’un nouvel espace dédié aux parfums et à la beauté. Conçu autour de l’excellence du service et d’expériences exclusives, cet écrin accueille un salon de consultation premium ainsi qu’une suite de soin Dior située à l’arrière de la boutique. L’ensemble renforce le rayonnement de la Maison et crée un lien privilégié avec l’univers de la Couture.',
          },
        ],
        photos: [P('dhk-1','std'), P('dhk-2','std'), P('dhk-3','std'), P('dhk-4','std')],
        gallery: [
          [{ s: 'dhk-1', ar: 'std', c: 3 }, { s: 'dhk-2', ar: 'std', c: 3 }],
          [{ s: 'dhk-3', ar: 'std', c: 3 }, { s: 'dhk-4', ar: 'std', c: 3 }],
        ],
      },
      {
        slug: 'fendi',
        title: 'FENDI',
        caption: { en: 'Design Studies – 2023', fr: 'Design Studies – 2023' },
        credits: {
          en: 'Artistic Direction : T.Mick / Labvert — Render : H. Holba',
          fr: 'Direction Artistique : T. Mick / Labvert — Render : H. Holba',
        },
        texts: [
          {
            en: 'Collaboration with Fendi on the design of dedicated Beauty spaces within the House’s Fashion boutiques. Created to support the launch of the fragrance and makeup collections, these spaces naturally extend the Fashion universe while enhancing brand consistency and the in-store customer experience.',
            fr: 'Collaboration avec Fendi pour la conception d’espaces Beauté au sein des boutiques Fashion de la Maison. Développés pour accompagner le lancement des collections parfums et maquillage, ces espaces prolongent naturellement l’univers Fashion tout en renforçant la cohérence de l’identité de marque et l’expérience client en boutique.',
          },
        ],
        photos: [P('fendi-1','tall'), P('fendi-2','wide'), P('fendi-3','wide'), P('fendi-4','wide')],
        gallery: [
          [{ s: 'fendi-1', ar: 'tall', c: 3 }],
          [{ s: 'fendi-2', ar: 'wide', c: 6 }, { s: 'fendi-3', ar: 'wide', c: 6 }],
          [{ s: 'fendi-4', ar: 'wide', c: 6 }],
        ],
      },
      {
        slug: 'celine',
        title: 'CÉLINE',
        caption: { en: 'Design Studies – 2020', fr: 'Design Studies – 2020' },
        credits: {
          en: 'Artistic Direction : T. Mick / Labvert',
          fr: 'Direction Artistique : T. Mick / Labvert',
        },
        texts: [
          {
            en: 'Research and development of a department store counter for the launch of make-up, complementing the House’s fragrance and accessories collections. The project aimed to translate Céline’s elegant and minimalist identity into a refined and cohesive retail experience. Display concepts were developed for the makeup collection to enhance product visibility and customer engagement.',
            fr: 'Recherche et développement d’un comptoir department store pour le lancement de la gamme maquillage, en complément des collections de parfums et d’accessoires. Le projet visait à traduire l’identité élégante et minimaliste de la Maison à travers une expérience retail cohérente et raffinée. Développement de concepts de display dédiés à la présentation du maquillage, favorisant la visibilité des produits et l’expérience client.',
          },
        ],
        photos: [P('celine-1','wide'), P('celine-2','wide'), P('celine-3','wide')],
        gallery: [
          [{ s: 'celine-1', ar: 'wide', c: 6 }, { s: 'celine-2', ar: 'wide', c: 6 }],
          [{ s: 'celine-3', ar: 'wide', c: 6 }],
        ],
      },
      {
        slug: 'givenchy',
        title: 'GIVENCHY',
        caption: { en: 'Design Studies – 2021', fr: 'Design Studies – 2021' },
        credits: {
          en: 'Artistic Direction : T. Mick / Labvert',
          fr: 'Direction Artistique : T. Mick / Labvert',
        },
        texts: [
          {
            en: 'Design research and development of a department store counter for the rollout of a high perfumery collection. The project aimed to translate the House’s distinctive identity and its minimalist yet unconventional codes into a refined and cohesive retail experience. A fragrance display console and presentation table were developed to enhance product visibility and elevate the customer experience.',
            fr: 'Recherche et développement d’un comptoir department store pour le déploiement de la haute parfumerie. Le projet visait à traduire l’identité et les codes minimaliste et décalé de la Maison à travers une expérience retail cohérente et raffinée. Développement d’une console et d’une table de présentation parfums, favorisant la visibilité des produits et l’expérience client.',
          },
        ],
        photos: [P('givenchy-1','wide'), P('givenchy-2','wide'), P('givenchy-4','wide')],
        gallery: [
          [{ s: 'givenchy-1', ar: 'wide', c: 6 }, { s: 'givenchy-2', ar: 'wide', c: 6 }],
          [{ s: 'givenchy-4', ar: 'wide', c: 6 }],
        ],
      },
      {
        slug: 'beverly-hills',
        title: 'BEVERLY HILLS',
        caption: { en: 'Design Studies – 2018 – 1200 sqm', fr: 'Design Studies – 2018 – 1200 m²' },
        credits: {
          en: 'Artistic Direction : T.Mick / Labvert — Render : H. Holba',
          fr: 'Direction Artistique : T.Mick / Labvert — Render : H. Holba',
        },
        texts: [
          {
            en: 'Set in the hills of Beverly Hills, this two-level private residence offers sweeping panoramic views over Los Angeles. Inspired by the elegance of 1950s California modernism, the interior architecture combines clean lines, natural materials and open spaces, creating a seamless dialogue between interiors, light and landscape.',
            fr: 'Située sur les hauteurs de Beverly Hills, cette résidence privée se déploie sur deux niveaux et offre une vue panoramique exceptionnelle sur Los Angeles. Inspirée par l’élégance du modernisme californien des années 1950, l’architecture intérieure associe lignes épurées, matériaux naturels et espaces ouverts, dans un dialogue constant entre intérieur, lumière et paysage.',
          },
        ],
        photos: [P('bev-1','wide'), P('bev-2','wide'), P('bev-3','wide'), P('bev-4','wide'), P('bev-5','wide'), P('bev-6','wide'), P('bev-7','wide'), P('bev-8','wide')],
        gallery: [
          [{ s: 'bev-1', ar: 'wide', c: 6 }, { s: 'bev-2', ar: 'wide', c: 6 }],
          [{ s: 'bev-3', ar: 'wide', c: 6 }, { s: 'bev-4', ar: 'wide', c: 6 }],
          [{ s: 'bev-5', ar: 'wide', c: 6 }, { s: 'bev-6', ar: 'wide', c: 6 }],
          [{ s: 'bev-7', ar: 'wide', c: 6 }, { s: 'bev-8', ar: 'wide', c: 6 }],
        ],
      },
    ],
  },
];
